import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedDuration } from 'LearningCenterUI/components/I18n';
import getLang from 'I18n/utils/getLang';
import { useParams } from 'react-router-dom';
import OverviewModalDescriptionSection from '../../components/TrackLessonOverviewModal/subcomponents/OverviewModalDescriptionSection'; //@ts-expect-error Could not find declaration file for module

import useAvailableLanguages from '../../hooks/useAvailableLanguages';
import OverviewModalCurriculumSection from '../../components/TrackLessonOverviewModal/subcomponents/OverviewModalCurriculumSection';
import ReducedCardLayout from '../../components/ContentCards/ReducedContentCard/subcomponents/ReducedCardLayout';
import { useMemo } from 'react';
import UsageTracker from '../../utils/UsageTracker'; //@ts-expect-error Could not find declaration file for module

import OverviewModalProfessorsSection from '../../components/TrackLessonOverviewModal/subcomponents/OverviewModalProfessorsSection'; //@ts-expect-error Could not find declaration file for module

import chapterThumbnailUrl from 'bender-url!../../../images/pngs/chapter_thumbnail.png'; //@ts-expect-error Could not find declaration file for module

import practicalExerciseThumbnailUrl from 'bender-url!../../../images/pngs/practical_exercise_thumbnail.png'; //@ts-expect-error Could not find declaration file for module

import quizThumbnailUrl from 'bender-url!../../../images/pngs/quiz_thumbnail.png';
import { useOverviewNavigation } from '../../features/tracks';
import { useFullLesson } from '../../features/lessons/lessonQueries';
import OverviewContent from '../../components/TrackLessonOverviewModal/subcomponents/OverviewContent';
import { useSelector } from 'react-redux';
import { getLesson //@ts-expect-error Could not find declaration file for module
} from '../../selectors/lessonSelectors';
import { FILTER_TYPES } from '../../constants/TopFilterConstants'; // @ts-expect-error Could not find a declaration file for module

import { useSearchParam } from '../../hooks/searchParamHooks';
import { CardMenuIcon } from '../../features/cardMenu';
const FallbackThumbnailUrls = {
  CHAPTER: chapterThumbnailUrl,
  PRACTICAL_EXERCISE_FLOW: practicalExerciseThumbnailUrl,
  QUIZ: quizThumbnailUrl
};

const LessonOverviewModalContainer = ({
  lessonId: lessonIdFromProps,
  language: languageFromProps,
  allowFullWidthChildren
}) => {
  const {
    source,
    lessonId: lessonIdFromParams,
    language: paramLanguage
  } = useParams();
  const lessonId = lessonIdFromProps && lessonIdFromProps.toString() || lessonIdFromParams;
  const [[searchParamLanguage]] = useSearchParam(FILTER_TYPES.LANGUAGE);
  const {
    goTo
  } = useOverviewNavigation();
  const {
    availableLanguagesLoading,
    availableLanguagesData
  } = useAvailableLanguages('lesson', lessonId);
  const language = useMemo(() => {
    const chosenLanguage = (languageFromProps || paramLanguage || searchParamLanguage || getLang()).toUpperCase();

    if (availableLanguagesData && availableLanguagesData.length && !availableLanguagesData.includes(chosenLanguage)) {
      // default to English if available
      return availableLanguagesData.includes('EN') ? 'EN' : availableLanguagesData[0];
    }

    return chosenLanguage;
  }, [availableLanguagesData, languageFromProps, paramLanguage, searchParamLanguage]);
  const {
    lessonLoading: loading,
    lesson,
    lessonError: error
  } = useFullLesson(Number(lessonId), language, availableLanguagesLoading);
  const lessonContent = useSelector(state => getLesson(state, {
    lessonId
  }));
  const deprecated = lessonContent && lessonContent.get('deprecated');
  const deprecationCta = lessonContent && lessonContent.get('deprecationCta');
  const videoId = useMemo(() => {
    if (!lesson) return undefined;

    if (lesson.introVideo) {
      return lesson.introVideo.vidyardUuid;
    }

    const videoContent = lesson.content.find(content => content.vidyardUuid);

    if (videoContent) {
      return videoContent.vidyardUuid;
    }

    return undefined;
  }, [lesson]);
  const professors = useMemo(() => {
    if (!lesson) return [];
    const professorsById = {};
    lesson.content.forEach(asset => {
      if (asset.professors) {
        asset.professors.forEach(professor => {
          professorsById[professor.id] = professor;
        });
      }
    });
    return Object.values(professorsById);
  }, [lesson]);
  const curriculumContent = useMemo(() => {
    if (!lesson) return [];
    return lesson.content.filter(content => content.contentType !== 'LINK');
  }, [lesson]);

  const handleChangeSelectedLanguage = ({
    target: {
      value
    }
  }) => {
    UsageTracker.track('interaction', {
      action: 'overview-modal-change-language',
      appearsIn: source,
      lessonId: lesson ? lesson.id : null,
      name: lesson ? lesson.name : null,
      previousLanguage: language,
      newLanguage: value
    });
    goTo({
      id: parseInt(lessonId, 10),
      type: 'lesson',
      language: value
    });
  };

  const handleEnroll = () => {
    UsageTracker.track('interaction', {
      action: 'overview-modal-enroll',
      appearsIn: source,
      contentLanguage: language,
      contentType: 'LESSON',
      lessonId: lesson ? lesson.id : null,
      name: lesson ? lesson.name : null
    });
  };

  const handleContentClick = (content, index) => () => {
    UsageTracker.track('interaction', {
      action: 'content-card-click',
      contentType: 'ASSET',
      assetId: content.id,
      appearsIn: 'lesson-overview-curriculum',
      position: index + 1,
      name: content.name,
      style: 'reduced',
      language
    });
  };

  return /*#__PURE__*/_jsxs(OverviewContent, {
    allowFullWidthChildren: allowFullWidthChildren,
    deprecated: deprecated,
    deprecationCta: deprecationCta,
    error: error,
    fallbackThumbnailUrl: lesson && lesson.previewThumbnailRectangleUrl,
    headerIcons: /*#__PURE__*/_jsx(CardMenuIcon, {
      language: language,
      lessonId: parseInt(lessonId, 10),
      use: "on-dark"
    }),
    loading: loading || availableLanguagesLoading,
    videoId: videoId,
    children: [/*#__PURE__*/_jsx(OverviewModalDescriptionSection, {
      availableLanguages: availableLanguagesData,
      availableLanguagesLoading: availableLanguagesLoading,
      contentList: lesson && lesson.content,
      description: lesson && lesson.description,
      duration: lesson && /*#__PURE__*/_jsx(FormattedDuration, {
        from: new Date().getTime() - lesson.duration * 1000
      }),
      hasStudyGuide: lesson && !!lesson.studyGuide,
      id: lesson && lesson.id,
      onChangeSelectedLanguage: handleChangeSelectedLanguage,
      onEnroll: handleEnroll,
      selectedLanguage: language,
      title: lesson && lesson.name,
      type: "LESSON"
    }), !!professors.length && /*#__PURE__*/_jsx(OverviewModalProfessorsSection, {
      language: language,
      professors: professors
    }), !!curriculumContent.length && /*#__PURE__*/_jsx(OverviewModalCurriculumSection, {
      children: curriculumContent.map((content, index) => /*#__PURE__*/_jsx(ReducedCardLayout, {
        contentId: content.id,
        name: content.name,
        onClick: handleContentClick(content, index),
        thumbnailUrl: content.previewThumbnailSquareUrl || FallbackThumbnailUrls[content.contentType] || `https://play.vidyard.com/${content.vidyardUuid}.jpg`,
        to: `/lessons/${lessonId}/${content.id}?language=${language}`,
        use: "on-dark",
        verticalGap: 28,
        children: /*#__PURE__*/_jsx(FormattedDuration, {
          from: new Date().getTime() - (content.duration || 0) * 1000
        })
      }, content.id))
    })]
  });
};

export default LessonOverviewModalContainer;